import React, { useState } from "react";
import { apiPost } from "../utils/apiClient";

const ContactPage: React.FC = () => {
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async () => {
        if (!subject || !message) {
            alert("件名と内容を入力してください");
            return;
        }

        setSending(true);
        try {
            await apiPost("/api/contact", {
                subject,
                message,
            });
            setDone(true);
            setSubject("");
            setMessage("");
        } catch {
            alert("送信に失敗しました");
        } finally {
            setSending(false);
        }
    };

    if (done) {
        return (
            <div className="max-w-xl bg-white rounded-xl border p-6">
                <h2 className="text-lg font-semibold mb-2">送信完了</h2>
                <p className="text-sm text-slate-600">
                    お問い合わせありがとうございました。内容を確認の上、ご連絡いたします。
                </p>
            </div>
        );
    }

    return (
        <div className="max-w-xl bg-white rounded-xl border p-6 space-y-4">
            <h1 className="text-lg font-semibold">お問い合わせ</h1>
            <p className="text-sm text-slate-500 leading-relaxed">
                ご利用中に困ったこと・ご要望などをお気軽にお送りください。内容を確認のうえ、担当者より順次ご返信いたします。
            </p>

            <div>
                <label className="text-sm">件名</label>
                <input
                    className="w-full border rounded px-3 py-2"
                    placeholder="例：〇〇の使い方について"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                />
            </div>

            <div>
                <label className="text-sm">内容</label>
                <textarea
                    className="w-full border rounded px-3 py-2 h-32"
                    placeholder="お問い合わせ内容をできるだけ具体的にご記入ください。"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </div>

            <button
                onClick={submit}
                disabled={sending}
                className="px-4 py-2 rounded bg-blue-600 text-white disabled:opacity-50"
            >
                {sending ? "送信中…" : "送信"}
            </button>
        </div>
    );
};

export default ContactPage;
